import React, { useEffect, useState, useCallback } from "react";
import { Box } from "@chakra-ui/layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Logo } from "../logo";
import { Photos } from "../photos";
import { Videos } from "../videos";
import { SearchBar } from "../searchBar";
import { Spinner } from "@chakra-ui/react";
import { usePixabaySearch } from "../../hooks";
import useScrollPosition from "@react-hook/window-scroll";
import { Tabs, TabPanels, TabPanel } from "@chakra-ui/react";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { IMainProp } from './main.types';
import '../../styles/styles.scss';

const LoadingSpinner = () => (
  <Box display="flex" justifyContent="center" m={10}>
    <Spinner />
  </Box>
);

const theme = extendTheme({
  styles: {
    global: {
      ".video-react-fluid": {
        padding: "0!important",
      },
      ".bpb": {
        display: "none",
      },
    },
  },
});

export function Main(props: IMainProp) {
  const [query, setQuery] = useState({ q: "", index: 0 });
  const {
    loading,
    photos,
    videos,
    search,
    fetchMoreData,
    loadmore,
    setLoadMore,
    setPage,
    fetchMoreVideoData
  } = usePixabaySearch();
  const [itemSelected, setItemSelected] = useState(false);
  const scroll = useScrollPosition();
  const [tabIndex, setTabIndex] = useState(0);
  const [itemSelectedUrl, setItemSelectedUrl] = useState({
    item_url: "",
    item_type: "",
    thumbnail: ""
  });

  useEffect(() => {
    var totalPageHeight = document.body.scrollHeight;
    var scrollPoint = window.scrollY + window.innerHeight;
    let percentage = (scrollPoint / totalPageHeight) * 100;
    if (percentage >= 99.5 && loadmore) {
      if(tabIndex === 1){
        fetchMoreVideoData();
      }else{
        fetchMoreData()
      }
    }
  }, [scroll]);

  const onItemSelectedCb = useCallback(
    (isSelected: any) => {
      setItemSelected(isSelected);
    },
    [itemSelected]
  );

  const onSelectedTemUrlCb = useCallback(
    (obj: any) => {
      setItemSelectedUrl(obj);
    },
    [itemSelectedUrl]
  );

  const handleTabsChange = (index: any) => {
    setPage(0);
    setLoadMore(true);
    setTabIndex(index);
    setItemSelected(false);
    let q = query.q || "";
    search({ q: q, index: index });
  };

  const handleQueryChange = (value: any) => {
    setPage(0);
    setLoadMore(true);
    setQuery({ q: value, index: tabIndex });
  };

  const handleSubmit = (empty?: boolean) => {
    setPage(0);
    setLoadMore(true);
    if (empty) {
      search({ q: "", index: tabIndex });
    } else {
      let q = query.q || "";
      search({ q: q, index: tabIndex });
    }
    setItemSelected(false);
  };

  //geturl called on add button which has be disabled for now
  const geturl = (e: any) => {
    if (itemSelectedUrl.item_type === "image") {
      const returnJson = {
        action: "create",
        type: "overlay",
        file: itemSelectedUrl.item_url,
      };

      props.getPixabayData(returnJson);

      if (window.vlogr) {
        window.vlogr.addData(1, JSON.stringify(returnJson));
      }
      if (window.webkit) {
        window.webkit.messageHandlers.addData.postMessage(returnJson);
      }
    } else {
      const returnJson = {
        action: "create",
        type: "video",
        file: itemSelectedUrl.item_url,
      };

      props.getPixabayData(returnJson);

      if (window.vlogr) {
        window.vlogr.addData(1, JSON.stringify(returnJson));
      }
      if (window.webkit) {
        window.webkit.messageHandlers.addData.postMessage(returnJson);
      }
    }
    setItemSelected(false);
    setItemSelectedUrl({ item_url: "", item_type: "",thumbnail: "" });
  };

  return (
    <ChakraProvider theme={theme}>
      <div>
        <HelmetProvider>
          <Helmet>
            <link rel="icon" href="/favicon.ico" />
          </Helmet>
        </HelmetProvider>

        <Box
          zIndex={100}
          paddingTop="10px"
          position="sticky"
          top={0}
          background="white"
          paddingBottom="15px"
        >
          <Box height="50px" marginInline="16px">
            <Logo />
          </Box>
          <Box height="100%" marginInline="20px">
            <SearchBar
              query={query.q}
              onChange={handleQueryChange}
              
              onSubmit={handleSubmit}
            />
          </Box>
          <div>
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 2000,
            background: "#ffffff",
          }}
        >
        <div className="header">
          <div
            className="tab-navigation"
          >
            <button
              className={`tab-button ${tabIndex === 0 ? "active" : ""}`}
              onClick={() => handleTabsChange(0)}
              style={{ borderBottom : tabIndex === 0 ? '1px solid #2F2F2F' : '1px solid #E0E0E0', color: tabIndex === 0 ? '#2F2F2F' : '#979797' }}
            >
              Photo
            </button>
        
         
            <button
              className={`tab-button ${tabIndex === 1 ? "active" : ""}`}
              onClick={() => handleTabsChange(1)}
              style={{ borderBottom : tabIndex === 1 ? '1px solid #2F2F2F' : '1px solid #E0E0E0', color: tabIndex === 1 ? '#2F2F2F' : '#979797' }}
            >
              Video
            </button>
          </div>
        </div>
        </div>
        </div>
        </Box>
          {/* JSX for the add button on selecting an image */}
          {/* <div style={{display:itemSelected?'block':'none',position: 'sticky',top: '90%',marginTop:'-50px',textAlign:'center',zIndex:99}}>
                <input style={{
                  fontFamily:'sans-serif',
                  fontSize:'18px',
                  fontWeight:'bold',
                  background: "linear-gradient(179.32deg, #3DBBFD -91.95%, #0179FF 99.45%)",
                  boxSizing:'border-box',
                  borderRadius: '12px',
                  width: '80%',
                  maxWidth: '350px',
                  color:'#FFFFFF',
                  height: '50px'}} 
                  type="button" 
                  onClick = {geturl} 
                  value="Add"/>
              </div> */}

              

        {tabIndex === 0 && (
          <Box height="100%" marginInline="20px" style={{ cursor: "pointer" }}>
            {photos && (
              <>
                {/*@ts-ignore */}
                <Photos
                  photos={photos}
                      onItemSelectedCb={onItemSelectedCb}
                      onSelectedTemUrlCb={onSelectedTemUrlCb}
                      itemSelected={itemSelected}
                      itemSelectedUrl={itemSelectedUrl}
                      getPixabayData={props.getPixabayData}
                      onDragStart={props.onDragStart}
                      onDragEnd={props.onDragEnd}
                />
              </>
            )}
            {loadmore ? <LoadingSpinner /> : <></>}
          </Box>
        )}

        {tabIndex === 1 && (
          <Box height="100%" marginInline="20px" style={{ cursor: "pointer" }}>
            {videos && (
              <>
                <Videos
                  videos={videos}
                      onItemSelectedCb={onItemSelectedCb}
                      onSelectedTemUrlCb={onSelectedTemUrlCb}
                      itemSelected={itemSelected}
                      itemSelectedUrl={itemSelectedUrl}
                      getPixabayData={props.getPixabayData}
                      onDragStart={props.onDragStart}
                      onDragEnd={props.onDragEnd}
                />
              </>
            )}
          </Box>
        )}
      </div>   
    </ChakraProvider>
  );
}
